'use client'
// TODO: this use state is really necessary?
import { useState } from 'react'
import { MediaImageStandard } from 'components/Contentful'
import styles from './HandwrittenText.module.css'

const HandwrittenText = ({ alt, content }) => {
  const [loaded, setLoaded] = useState(false)

  return (
    <div className={styles['handwritten']} data-loaded={loaded}>
      <MediaImageStandard alt={alt} content={content} onLoad={() => setLoaded(true)} />
    </div>
  )
}

export { HandwrittenText }
